import { useSearchParams } from "react-router"

export function useTabParams(paramName = "view") {
  const [searchParams, setSearchParams] = useSearchParams()

  const currentTab = searchParams.get(paramName) || ""

  const setTab = (value: string) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set(paramName, value)
    setSearchParams(newParams, { replace: false }) // keep other params intact
  }

  return { currentTab, setTab }
}
